export const quickLinks = [
  {
    title: 'meeting.nav.myMeeting',
    route: '/meeting/my-meeting',
    permission: 'general',
    visible: () => true
  }
]
